import { SecondaryButton } from './styles';
import { FilterRadioButtonInterface } from './interface';

export default function FilterRadioButton({
  children, onClick, selected, invisible, sameWidth, nowrap, smallText
}: FilterRadioButtonInterface) {
  return (
    <SecondaryButton
      onClick={onClick}
      selected={selected}
      invisible={invisible}
      sameWidth={sameWidth}
      nowrap={nowrap}
      smallText={smallText}
    >
      {children}
    </SecondaryButton>
  );
}
